export default __webpack_public_path__ + "static/article-5-restaurants-you-can-visit-with-your-infinity-rewards-4bedcd921d89f1fa33b8b76139416f8a.jpg";